import React from "react";

const PlannerFirstChat = ({ formData }) => {
  if (!formData) return null;

  const {
    user_goals,
    self_assessment,
    period,
    weekly_study_hours,
    strengths,
    weaknesses,
  } = formData;

  // Map learning areas to Korean
  const areaLabels = {
    hearing: "듣기",
    reading: "읽기",
    writing: "쓰기",
    speaking: "말하기",
    grammar: "문법",
    vocabulary: "어휘",
  };

  // Get active learning areas (strengths) - now array of strings
  const activeLearningAreas = (strengths || []).map(
    (key) => areaLabels[key] || key
  );

  // Get weak areas (weaknesses) - now array of strings
  const activeWeakAreas = (weaknesses || []).map(
    (key) => areaLabels[key] || key
  );

  return (
    <div className="learning-plan-summary">
      <div className="topik-progression">
        <span className="current-level">
          {self_assessment.toUpperCase().replace("_", " ")}
        </span>
        <span className="arrow">→</span>
        <span className="target-level">
          {user_goals.toUpperCase().replace("_", " ")}
        </span>
      </div>

      <div className="plan-details">
        <div className="detail-item">
          <span className="keduall-ai-tag">{period}</span>
        </div>

        <div className="detail-item">
          <span className="keduall-ai-tag">{weekly_study_hours}</span>
        </div>
      </div>

      <div className="learning-areas">
        {activeLearningAreas.length > 0 && (
          <div className="areas-section">
            <div className="areas-tags">
              {activeLearningAreas.map((area, index) => (
                <span
                  key={index}
                  className={`keduall-ai-tag ${area.toLowerCase()}`}
                >
                  {area}
                </span>
              ))}
            </div>
          </div>
        )}

        {activeWeakAreas.length > 0 && (
          <div className="areas-section">
            <div className="areas-tags">
              {activeWeakAreas.map((area, index) => (
                <span
                  key={index}
                  className={`keduall-ai-tag ${area.toLowerCase()}`}
                >
                  {area}
                </span>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(PlannerFirstChat);
